module.exports = __webpack_public_path__ + "img/product_65.7a82cab.svg";